/* istanbul ignore file */
/**
 * Created by gboue on 08/22/22
 * File: idp
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */
import type { VFC } from 'react'
import Providers from './homepage/Providers'

/**
 *   Identities and providers page
 */
const IDP: VFC = () => <Providers/>

export default IDP
